import classes from "./ModalView.module.css";
import {
    Badge,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    styled,
    TextField,
    Typography,
} from "@mui/material";
import React, {useState, Fragment, useEffect, useRef} from "react";
import logo from "../../../store/logo.png"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import axios from 'axios';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {path} from "../../../routes";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker, LocalizationProvider, TimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import imageCompression from "browser-image-compression";

const ModalView = (props) => {
    const MAX_UPLOAD_MB = 700;
    const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
    const minutes = [0, 15, 30, 60, 90]
    // Fairmont Golden Prague – jen pro tento org: pole "Name" se jmenuje "Title"
    // a navíc je k dispozici "Subtitle" (podnadpis pod hlavním nadpisem na displeji).
    const FAIRMONT_GOLDEN_PRAGUE_ORG_ID = '7A67452A-F5D4-430D-B283-8A93B28B425C';
    const isFairmontOrg = String(props.cred?.cOrganization_id || '').trim().toUpperCase() === FAIRMONT_GOLDEN_PRAGUE_ORG_ID;
    const nameFieldLabel = isFairmontOrg ? 'Title' : 'Name';
    const publicBaseUrl = String(path || '')
        .replace(/\/api\/?$/i, '')
        .replace(/\/$/, '');

    const toPublicUploadUrl = (p) => {
        if (!p) return '';
        if (String(p).startsWith('http')) return String(p);
        // Extract filename from path (remove all prefixes)
        const cleaned = String(p)
            .replace(/\\/g, '/')
            .replace(/^\/+/, '')
            .replace(/^admin\/uploads\//i, '')
            .replace(/^uploads\//i, '')
            .replace(/^admin\//i, '');
        // Always use /uploads/ prefix in the final URL
        return `${publicBaseUrl}/uploads/${cleaned}`;
    };

    // Menu cards (groupID=99) are not tied to devices.
    // "No group" cards (groupID=0) are also not tied to a specific display.
    const isMenuCard = props.groupID === 99;
    const isNoGroupCard = props.groupID === 0;
    const groupLockedForAdd = props.V === 1 && props.groupID != null && props.groupID !== 99 && props.groupID !== 0;
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    const [screenID, setScreenID] = React.useState('');
    // IMPORTANT: groupID can be 0 (no group) – don't use || fallback which would turn 0 into 99
    const [group_id, setgroup_id] = React.useState(props.groupID ?? 99);
    const [bodyCalUpdated, setBodyCalUpdated] = React.useState(props.modalBodyUpdate);
    const [valueDate, setValueDate] = React.useState(dayjs());
    const [deviceScreen, setDeviceScreen] = React.useState([]);
    const [valueTime, setValueTime] = React.useState(dayjs());
    const [isUpdate, setIsUpdate] = useState(false);
    const [body, setBody] = useState(props.ModalBody);
    const [file, setFile] = useState(null);
    const [fileEdit, setFileEdit] = useState(null);
    const [imageUrlEdit, setImageUrlEdit] = useState('');
    const [isVideoPreview, setIsVideoPreview] = useState(false);
    const [isVideoEditPreview, setIsVideoEditPreview] = useState(false);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
    const [text, setText] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [textName, setTextName] = useState('');
    const [textCont, setTextCont] = useState('');
    const [isError, setIsError] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [imageUrl2, setImageUrl2] = useState('');
    const [imageUrl3, setImageUrl3] = useState('');
    const fileInputRef = useRef(null);
    const [isSend, setIsSend] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [contentMode, setContentMode] = useState('file'); // file | url
    const [externalUrl, setExternalUrl] = useState('');
    const [displays, setDisplays] = useState([]);
    /** Skutečné skupiny karet (cSlideGroup) – ne zaměňovat s device_group (1=Display, 2=Kiosk) */
    const [slideGroups, setSlideGroups] = useState([]);
    const [selectedDisplay, setSelectedDisplay] = useState('');
    const [existingCards, setExistingCards] = useState([]);
    const [recordTemplates, setRecordTemplates] = useState([]);
    const [selectedTemplateKey, setSelectedTemplateKey] = useState('');
    const [selectedTemplatePath, setSelectedTemplatePath] = useState('');
    const [poster, setPoster] = useState(null);
    const [posterUrl, setPosterUrl] = useState('');
    const posterInputRef = React.useRef(null);
    const isVideoFile = (f) => {
        if (!f) return false;
        const mime = String(f.type || '').toLowerCase();
        if (mime.startsWith('video/')) return true;
        return /\.(mp4|webm|mov|m4v|avi|mkv)$/i.test(String(f.name || ''));
    };
    const isPdfFile = (f) => {
        if (!f) return false;
        const mime = String(f.type || '').toLowerCase();
        if (mime === 'application/pdf') return true;
        return /\.pdf$/i.test(String(f.name || ''));
    };
    const isVideoPath = (p) => /\.(mp4|webm|mov|m4v|avi|mkv)(\?.*)?$/i.test(String(p || ''));
    const isPdfPath = (p) => /\.pdf(\?.*)?$/i.test(String(p || ''));
    const [bodyCalendar, setBodyCalendar] = useState({
        name: "",
        device: "",
        devices: [],
        date: null,
        timeFrom: null,
        timeTo: null,
        room: "A-D",
        showBefore: 0
    });
    const [bodyForCreation, setBodyForCreation] = useState({
        id: props.addID,
        Header: null,
        Body: {
            file: null,
            imgURL: null,

        }
    })
    const [ele, setEle] = useState([]);
    const [device, setdevice] = React.useState(props.device);
    const [rooms, setRooms] = React.useState([]);
    const [dateAct, setDateAct] = React.useState(bodyCalUpdated.dateFrom.substring(0, 16));
    const [defaultIdNav, setDefaultIdNav] = React.useState(1);
    const [carouselCurrentIndex, setCarouselCurrentIndex] = React.useState(0);
    // Parse dates as local time without timezone conversion
    const parseLocalDate = (dateStr) => {
        if (!dateStr) return '';
        const str = dateStr.substring(0, 19).replace(' ', 'T');
        // Remove timezone info if present and parse as local time
        return str.replace(/[+-]\d{2}:?\d{2}$/, '').replace('Z', '');
    };
    const [dateFr, setDateFr] = React.useState(parseLocalDate(props.modalBodyUpdate.dateFrom));
    const [dateTo, setDateTo] = React.useState(parseLocalDate(props.modalBodyUpdate.dateTo));
    // Poster (full-screen) v editu – nový soubor / zachovat / odebrat
    const [posterP, setPosterP] = React.useState(null);
    const [posterUrlP, setPosterUrlP] = React.useState(props.modalBodyUpdate?.posterPath ? toPublicUploadUrl(props.modalBodyUpdate.posterPath) : '');
    const [existingPosterP, setExistingPosterP] = React.useState(props.modalBodyUpdate?.posterPath || '');
    const [removePosterP, setRemovePosterP] = React.useState(false);
    const posterEditInputRef = React.useRef(null);
    const [showBefore, setShowBefore] = React.useState(props.modalBodyUpdate?.showBefore ?? 0);
    const [deviceP, setDeviceP] = React.useState(props.modalBodyUpdate?.cDevice_id ?? "");
    const [roomP, setRoomP] = React.useState(props.modalBodyUpdate?.roomDescription ?? "");
    const [textP, setTextP] = React.useState(props.modalBodyUpdate.recordDescription);
    const [subtitleP, setSubtitleP] = React.useState(props.modalBodyUpdate?.subtitle ?? '');
    const [showBefore_date, setShowBefore_date] = React.useState(props.modalBodyUpdate.showBefore_date);
    useEffect(() => {
        const firstId = Array.isArray(bodyCalendar.devices) && bodyCalendar.devices.length > 0 ? bodyCalendar.devices[0] : bodyCalendar.device;
        for (let i = 0; i < deviceScreen.length; i++) {
            if (deviceScreen[i].id === firstId) {
                setBodyCalendar(prev => ({ ...prev, room: deviceScreen[i].roomGroup }));
                break;
            }
        }
    }, [bodyCalendar.device, bodyCalendar.devices])

    useEffect(() => {
        //console.warn(deviceP)
        for (let i = 0; i < deviceScreen.length; i++) {
            if (deviceScreen[i].id === deviceP) {
                setRoomP(deviceScreen[i].roomGroup);
            }
        }
    }, [deviceP])
    const setRoomGroup = (id) => {
        //console.error(bodyCalUpdated);
        // console.warn(id);
        for (let i = 0; i < deviceScreen.length; i++) {
            if (deviceScreen[i].id === id) {
                setBodyCalendar((prevBodyCalUpdated) => ({...prevBodyCalUpdated, room: deviceScreen[i].roomGroup}));
            }
        }
    }

    const handleFileCut = async (file) => {

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 800,
            useWebWorker: true,
        };

        try {
            const compressedFile = await imageCompression(file, options);
            const previewUrl = URL.createObjectURL(compressedFile);
            return previewUrl

            // uploadToServer(compressedFile);
        } catch (error) {
            console.error("Compression failed:", error);
        }
    };

    const validate_modal = async (event) => {
        const selectedDevices = Array.isArray(bodyCalendar.devices) ? bodyCalendar.devices : (bodyCalendar.device != null && bodyCalendar.device !== '' ? [bodyCalendar.device] : []);
        const hasDevice = selectedDevices.length > 0;
        const hasDate = bodyCalendar.date != null;
        const hasTimeFrom = bodyCalendar.timeFrom != null;
        const hasTimeTo = bodyCalendar.timeTo != null;
        const hasName = (text || '').trim() !== '';
        if (!hasDevice || !hasDate || !hasTimeFrom || !hasTimeTo || !hasName) {
            setIsError(true);
            return;
        }
        const d = bodyCalendar.date || valueDate || dayjs();
        const tFrom = bodyCalendar.timeFrom || valueTime || dayjs();
        const tTo = bodyCalendar.timeTo || valueTime?.add?.(1, 'hour') || dayjs().add(1, 'hour');
        const dateStr = `${d.$y ?? d.year()}-${String((d.$M ?? d.month()) + 1).padStart(2, '0')}-${String(d.$D ?? d.date()).padStart(2, '0')}`;
        const timeFromStr = `${String(tFrom.$H ?? tFrom.hour()).padStart(2, '0')}:${String(tFrom.$m ?? tFrom.minute()).padStart(2, '0')}:00`;
        const timeToStr = `${String(tTo.$H ?? tTo.hour()).padStart(2, '0')}:${String(tTo.$m ?? tTo.minute()).padStart(2, '0')}:00`;
        const newFrom = new Date(`${dateStr}T${timeFromStr}`).getTime();
        const newTo = new Date(`${dateStr}T${timeToStr}`).getTime();
        const toLocalTimeOnDay = (dateVal) => {
            const s = typeof dateVal === 'string' ? dateVal : (dateVal && typeof dateVal.toISOString === 'function') ? dateVal.toISOString() : '';
            if (!s) return NaN;
            const match = String(s).match(/[T ](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?(?:\.\d+)?/);
            if (!match) return NaN;
            const hh = String(match[1]).padStart(2, '0');
            const mm = String(match[2]).padStart(2, '0');
            const ss = (match[3] !== undefined && match[3] !== '') ? String(match[3]).padStart(2, '0') : '00';
            return new Date(`${dateStr}T${hh}:${mm}:${ss}`).getTime();
        };
        // Overlap checks intentionally disabled:
        // admin needs to allow multiple meetings in the same time slot on one display.
        setIsError(false);
        setIsSend(true);
        addnewRecordToCalendar(event);
    };
    const subtractMinutes = (date, minutes) => {
        const jsDate = date.toDate()
        return new Date(jsDate.getTime() - minutes * 60000);
    };

    const handleSubtractMinutes = () => {
        const newDate = subtractMinutes(bodyCalendar.timeFrom, bodyCalendar.showBefore);
        //console.warn("newDate - ",newDate)
        const formatted = dayjs(newDate).format('YYYY-MM-DDTHH:mm:ss');
        //console.warn("formated - ",formatted)
        return formatted
    };

    const addnewRecordToCalendar = async (event) => {
        const d = bodyCalendar.date || valueDate || dayjs();
        const tFrom = bodyCalendar.timeFrom || valueTime || dayjs();
        const tTo = bodyCalendar.timeTo || valueTime?.add?.(1, 'hour') || dayjs().add(1, 'hour');
        const date = `${d.$y ?? d.year()}-${String((d.$M ?? d.month()) + 1).padStart(2, "0")}-${String(d.$D ?? d.date()).padStart(2, "0")}`;
        const dtFrom = `${date} ${String(tFrom.$H ?? tFrom.hour()).padStart(2, "0")}:${String(tFrom.$m ?? tFrom.minute()).padStart(2, "0")}:00`;
        const dtTo = `${date} ${String(tTo.$H ?? tTo.hour()).padStart(2, "0")}:${String(tTo.$m ?? tTo.minute()).padStart(2, "0")}:00`;
        
        // Calculate showBefore_date correctly
        let showBeforeDate;
        try {
            const showBeforeMinutes = bodyCalendar.showBefore || 0;
            if (showBeforeMinutes === 0) {
                // If showBefore is 0, showBefore_date should be the same as dateFrom
                showBeforeDate = dtFrom;
            } else {
                const tFromDate = tFrom.toDate ? tFrom.toDate() : new Date(tFrom);
                const showBeforeTime = new Date(tFromDate.getTime() - showBeforeMinutes * 60000);
                const showBeforeHours = String(showBeforeTime.getHours()).padStart(2, "0");
                const showBeforeMins = String(showBeforeTime.getMinutes()).padStart(2, "0");
                const showBeforeSecs = String(showBeforeTime.getSeconds()).padStart(2, "0");
                showBeforeDate = `${date} ${showBeforeHours}:${showBeforeMins}:${showBeforeSecs}`;
            }
        } catch (e) {
            console.error('Error calculating showBefore_date:', e);
            // Fallback: use dateFrom if calculation fails
            showBeforeDate = dtFrom;
        }
        
        const selectedDevices = Array.isArray(bodyCalendar.devices) && bodyCalendar.devices.length > 0
            ? bodyCalendar.devices
            : (bodyCalendar.device != null && bodyCalendar.device !== '' ? [bodyCalendar.device] : []);
        if (selectedDevices.length === 0) return;
        const roomForDevice = (id) => {
            const dev = deviceScreen.find(x => x.id === id);
            return dev ? (dev.roomGroup ?? bodyCalendar.room) : bodyCalendar.room;
        };
        setIsUploading(true);
        try {
            for (let i = 0; i < selectedDevices.length; i++) {
                const iddevice = selectedDevices[i];
                const room = roomForDevice(iddevice);
                await handleUploadRecord(iddevice, dtFrom, dtTo, room, bodyCalendar.showBefore, showBeforeDate, { skipClose: true });
            }
            if (selectedDevices.length > 0) {
                alert(selectedDevices.length === 1 ? 'Saved to DB.' : `Saved to ${selectedDevices.length} devices.`);
                props.updateCount();
                props.close();
            }
        } finally {
            setIsSend(false);
            setIsUploading(false);
        }
    };
    const setDateUpdate_handler = (value) => {
        let date = `${value.$y}-${String(value.$M + 1).padStart(2, "0")}-${String(value.$D).padStart(2, "0")}`
        setBodyCalUpdated({...bodyCalUpdated, date: date})
        setDateAct(date)
    }
    const setDateTimeUpdate_handler = (value, th) => {
        let date = `${value.$y}-${String(value.$M + 1).padStart(2, "0")}-${String(value.$D).padStart(2, "0")}`
        let datetime = `${dateAct}T${String(value.$H).padStart(2, "0")}:${String(value.$m).padStart(2, "0")}:00`
        th == 1 ? setBodyCalUpdated({...bodyCalUpdated, dateFrom: datetime}) : setBodyCalUpdated({
            ...bodyCalUpdated,
            dateTo: datetime
        })
        let dt = datetime.slice(0, 11) + datetime.slice(-8)
        th == 1 ? setDateFr(dt) : setDateTo(dt)

    }
    const handleUploadRecord = async (iddevice, datefrom, dateto, room, showBefore, showBefore_date, options = {}) => {
        const { skipClose } = options;
        if (isUploading && !skipClose) return;
        if (!skipClose) setIsUploading(true);
        const formData = new FormData();
        if (file) formData.append('file', file);
        if (!file && selectedTemplatePath) formData.append('existingPath', selectedTemplatePath);
        formData.append('description', text);
        if (isFairmontOrg) formData.append('subtitle', subtitle ?? '');
        formData.append('iduser', props.cred.id);
        formData.append('iddevice', iddevice);
        formData.append('dateFrom', datefrom);
        formData.append('dateTo', dateto);
        formData.append('room', room);
        formData.append('showBefore', showBefore);
        formData.append('showBefore_date', showBefore_date);
        formData.append('cOrganization_id', props.cred.cOrganization_id);
        if (poster) formData.append('poster', poster);

        try {
            const response = await axios.post(`${path}/uploadRecordV2`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const inserted = response?.data?.[0]?.id ?? response?.data?.id;
            if (!skipClose) {
            alert(inserted ? `Saved to DB. Record id: ${inserted}` : 'Saved to DB.');
            props.updateCount();
            props.close();
            }
        } catch (error) {
            const msg = error?.response?.data ?? error?.message;
            console.error('Error uploading file:', error, msg);
            alert('Error uploading file: ' + (typeof msg === 'string' ? msg : JSON.stringify(msg)));
            throw error;
        } finally {
            if (!skipClose) setIsUploading(false);
        }
    };

    const handleUploadExplore = async () => {
        //debugger;
        if (!file2 || !file3) {
            alert('Add all pictures');
            return;
        }
        if (isUploading) return; // Prevent double-click
        setIsUploading(true);
        const formData = new FormData();
        formData.append('file', file2);
        formData.append('file2', file3);
        formData.append('header', textName);
        formData.append('content', textCont);

        try {
            const response = await axios.post(`${path}/uploadExplore`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            //console.error(response.data[0].id)

            alert('File uploaded successfully');
            //props.updateCount()
            props.close()
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Error uploading file');
        } finally {
            setIsUploading(false);
        }

    };

    const handleUpdateRecord = async () => {
        if (isUploading) return; // Prevent double-click
        setIsUploading(true);
        const dayStr = (dateFr || '').substring(0, 10);
        const newFrom = new Date(dateFr).getTime();
        const newTo = new Date(dateTo).getTime();
        const toLocalTimeOnDay = (dateVal) => {
            const s = typeof dateVal === 'string' ? dateVal : (dateVal && typeof dateVal.toISOString === 'function') ? dateVal.toISOString() : '';
            if (!s) return NaN;
            const match = String(s).match(/[T ](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?(?:\.\d+)?/);
            if (!match) return NaN;
            const hh = String(match[1]).padStart(2, '0');
            const mm = String(match[2]).padStart(2, '0');
            const ss = (match[3] !== undefined && match[3] !== '') ? String(match[3]).padStart(2, '0') : '00';
            return new Date(`${dayStr}T${hh}:${mm}:${ss}`).getTime();
        };
        // Overlap checks intentionally disabled:
        // allow editing records so they can overlap with existing ones.
        setIsError(false);
        try {
            // Calculate showBefore_date if showBefore is set
            let showBeforeDate = null;
            console.log('[Calendar/Edit] Updating record showBefore:', {
                recordID: bodyCalUpdated?.recordID,
                deviceP,
                oldShowBefore: bodyCalUpdated?.showBefore,
                newShowBefore: showBefore,
                dateFr,
                dateTo,
            });
            if (showBefore && showBefore > 0) {
                try {
                    const tFromDate = new Date(dateFr);
                    const showBeforeTime = new Date(tFromDate.getTime() - showBefore * 60000);
                    const date = dateFr.substring(0, 10);
                    const showBeforeHours = String(showBeforeTime.getHours()).padStart(2, "0");
                    const showBeforeMins = String(showBeforeTime.getMinutes()).padStart(2, "0");
                    const showBeforeSecs = String(showBeforeTime.getSeconds()).padStart(2, "0");
                    showBeforeDate = `${date} ${showBeforeHours}:${showBeforeMins}:${showBeforeSecs}`;
                } catch (e) {
                    console.error('Error calculating showBefore_date:', e);
                    showBeforeDate = dateFr;
                }
            } else {
                showBeforeDate = dateFr;
            }
            
            const formData = new FormData();
            formData.append('id', bodyCalUpdated.recordID);
            formData.append('description', textP);
            if (isFairmontOrg) formData.append('subtitle', subtitleP ?? '');
            // Poster: nový soubor / odebrat / zachovat stávající
            if (posterP) formData.append('poster', posterP);
            else if (removePosterP) formData.append('removePoster', '1');
            else if (existingPosterP) formData.append('existingPoster', existingPosterP);
            formData.append('iddevice', deviceP);
            formData.append('dateFrom', dateFr);
            formData.append('dateTo', dateTo);
            formData.append('room', roomP ?? '');
            formData.append('showBefore', showBefore ?? 0);
            formData.append('showBefore_date', showBeforeDate);
            if (fileEdit) formData.append('file', fileEdit);
            const resp = await axios.post(`${path}/updateRecordWithFile`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            console.log('[Calendar/Edit] updateRecordWithFile response:', resp?.data);
            alert('Updated successfully');
            props.updateCount();
            close_handler();
        } catch (error) {
            console.error('Error updating record:', error);
            alert('Error updating record');
        } finally {
            setIsUploading(false);
        }
    };

    const handleDeleteRecord = () => {
        props.deleteRecord(bodyCalUpdated.recordID)
    }

    const close_handler = () => {
        setFile(null);
        setImageUrl('');
        setFileEdit(null);
        setImageUrlEdit('');
        setText('');
        setSubtitle('');
        setTextName('');
        setTextCont('');
        setFile2(null);
        setFile3(null);
        setImageUrl2('');
        setImageUrl3('');
        setSelectedDisplay('');
        setgroup_id(props.groupID ?? 99);
        setExistingCards([]);
        setRecordTemplates([]);
        setSelectedTemplateKey('');
        setSelectedTemplatePath('');
        setPoster(null);
        setPosterUrl('');
        setIsError(false);
        setContentMode('file');
        setExternalUrl('');
        setIsVideoPreview(false);
        props.close();
    }

    const add_handler = (id) => {
        props.add({
            Header: text,
            Body: {
                file: file,
                imgURL: imageUrl,

            }
        })
        props.close()
    }

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        if (selectedFile) {
            setSelectedTemplateKey('');
            setSelectedTemplatePath('');
        }
        if (selectedFile) {
            const isVideo = isVideoFile(selectedFile);
            setIsVideoPreview(isVideo);
            if (isVideo) {
                setImageUrl(URL.createObjectURL(selectedFile));
            } else if (isPdfFile(selectedFile)) {
                // PDF preview rendering is intentionally disabled on client
                // to avoid worker fetch/runtime issues across environments.
                setImageUrl('');
            } else {
                const reader = new FileReader();
                reader.onload = (e) => {
                    setImageUrl(e.target.result);
                };
                reader.readAsDataURL(selectedFile);
            }
        } else {
            setIsVideoPreview(false);
            setImageUrl('');
        }
    };

    const handleFileChange2 = (event) => {
        const selectedFile = event.target.files[0];
        setFile2(selectedFile);
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageUrl2(e.target.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setImageUrl2('');
        }
    };

    const handleFileChange3 = (event) => {
        const selectedFile = event.target.files[0];
        setFile3(selectedFile);
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageUrl3(e.target.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setImageUrl3('');
        }
    };
    const delete_file_handler = (event) => {
        setFile(null);
        setImageUrl(selectedTemplatePath ? toPublicUploadUrl(selectedTemplatePath) : '');
        setIsVideoPreview(false);
        setBodyCalendar((prev) => ({ ...prev, file: null, imageUrl: null }));
        if (fileInputRef.current) fileInputRef.current.value = '';
    };
    const delete_file_handler2 = (event) => {
        setFile2(null);
        setImageUrl2('');
    };
    const delete_file_handler3 = (event) => {
        setFile3(null);
        setImageUrl3('');
    };

    const handleFileEditChange = (event) => {
        const selectedFile = event.target.files[0];
        setFileEdit(selectedFile);
        if (selectedFile) {
            const isVideo = isVideoFile(selectedFile);
            setIsVideoEditPreview(isVideo);
            if (isVideo) {
                setImageUrlEdit(URL.createObjectURL(selectedFile));
            } else {
            const reader = new FileReader();
            reader.onload = (e) => setImageUrlEdit(e.target.result);
            reader.readAsDataURL(selectedFile);
            }
        } else {
            setIsVideoEditPreview(false);
            setImageUrlEdit(bodyCalUpdated.path ? toPublicUploadUrl(bodyCalUpdated.path) : '');
        }
    };
    const delete_file_edit_handler = () => {
        setFileEdit(null);
        setIsVideoEditPreview(false);
        setImageUrlEdit(bodyCalUpdated.path ? toPublicUploadUrl(bodyCalUpdated.path) : '');
    };

    const handleTextChange = (event) => {
        setText(event.target.value);
        if (selectedTemplateKey) {
            setSelectedTemplateKey('');
            setSelectedTemplatePath('');
        }
    };

    const applyRecordTemplate = (key) => {
        setSelectedTemplateKey(key || '');
        const tpl = (recordTemplates || []).find((x) => x.key === key);
        if (!tpl) {
            setSelectedTemplatePath('');
            return;
        }
        setText(String(tpl.name || ''));
        const p = String(tpl.path || '').trim();
        setSelectedTemplatePath(p);
        setFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
        setImageUrl(p ? toPublicUploadUrl(p) : '');
        setIsVideoPreview(false);
    };

    const handleSubmit = (event) => {
        //event.preventDefault();
        // You can handle form submission here
        // Pokud je currentID nebo ModalBody.id nastavený, použít update místo add
        if (props.currentID || props.ModalBody?.id) {
            handleUpdate()
        } else {
        handleUpload()
        }

    };

    const delete_handler = () => {
        props.delFNC(props.currentID)
        props.close()
    }
    useEffect(() => {
        if (props.V == 1) {
            // Pokud je currentID nebo ModalBody.id nastavený, jde o update - inicializovat text z ModalBody
            if (props.currentID || props.ModalBody?.id) {
                if (props.ModalBody?.Header) {
                    setText(props.ModalBody.Header);
                }
                if (props.ModalBody?.Body?.imgURL) {
                    setImageUrl(props.ModalBody.Body.imgURL);
                }
            } else {
                // Add nové karty: vždy resetovat formulář, aby po odebrání a znovu „Přidat“ nebyla chyba
                setFile(null);
                setText('');
                setImageUrl('');
                setIsVideoPreview(false);
                setBodyCalendar((prev) => ({ ...prev, file: null, imageUrl: null }));
                if (fileInputRef.current) fileInputRef.current.value = '';
            }
            if (groupLockedForAdd) {
                // Group is chosen elsewhere (e.g. Diplomat slide groups) – just show that group
                setgroup_id(props.groupID);
                fetchExistingCards(props.groupID);
            } else {
                // Load displays when opening add modal (used e.g. in SpecOffer)
                fetchDisplays();
            }
        }
        if (props.V == 2) {
            if (props.ModalBody) {
                setText(props.ModalBody.Header);
                if (props.ModalBody.Body?.imgURL) setImageUrl(props.ModalBody.Body.imgURL);
            }
            if (props.carouselItems?.length && typeof props.carouselIndex === 'number') {
                setCarouselCurrentIndex(Math.min(props.carouselIndex, props.carouselItems.length - 1));
            }
        }
        if (props.V == 3 || props.V == 4) {
            setDeviceScreen(props.device || [])
            setRooms(props.rooms || [])
            setBodyCalUpdated(props.modalBodyUpdate || {})
            if (props.V == 3) {
                // Use selected day from calendar if provided, otherwise use current date
                const selectedDay = props.selectedDay ? dayjs(props.selectedDay) : dayjs();
                const now = dayjs();
                setValueDate(selectedDay);
                setValueTime(now);
                setShowBefore(0);
                setText('');
                setRecordTemplates([]);
                setSelectedTemplateKey('');
                setSelectedTemplatePath('');
                // Set device if provided (when clicking on a device)
                const deviceId = props.selectedDeviceId || '';
                setBodyCalendar(prev => ({ ...prev, date: selectedDay, timeFrom: now, timeTo: now.add(1, 'hour'), device: deviceId, showBefore: 0 }));
                if (props.cred?.cOrganization_id) {
                    axios
                        .get(`${path}/getRecordTemplatesV2?orgID=${encodeURIComponent(props.cred.cOrganization_id)}`)
                        .then((r) => {
                            const rows = Array.isArray(r.data) ? r.data : [];
                            setRecordTemplates(rows);
                        })
                        .catch(() => setRecordTemplates([]));
                }
            }
            if (props.V == 4 && props.modalBodyUpdate) {
                setDeviceP(props.modalBodyUpdate.cDevice_id ?? "");
                setRoomP(props.modalBodyUpdate.roomDescription ?? "");
                setShowBefore(props.modalBodyUpdate.showBefore ?? 0);
                setFileEdit(null);
                setImageUrlEdit(props.modalBodyUpdate.path ? toPublicUploadUrl(props.modalBodyUpdate.path) : '');
                // Update dateFr and dateTo when modal opens for editing - parse as local time
                if (props.modalBodyUpdate.dateFrom) {
                    setDateFr(parseLocalDate(props.modalBodyUpdate.dateFrom));
                }
                if (props.modalBodyUpdate.dateTo) {
                    setDateTo(parseLocalDate(props.modalBodyUpdate.dateTo));
                }
            }
        }
    }, [props.V, props.groupID, props.modalBodyUpdate])

    // Helper: safe selected device value for edit modal (avoid MUI out-of-range warning)
    const safeDeviceP = React.useMemo(() => {
        if (deviceP == null || deviceP === '') return '';
        const targetId = String(deviceP);
        const exists = deviceScreen.some(d => String(d.id) === targetId);
        return exists ? deviceP : '';
    }, [deviceP, deviceScreen]);

    // Update date and device when selectedDay or selectedDeviceId changes (for variant 3)
    useEffect(() => {
        if (props.V === 3) {
            if (props.selectedDay) {
                const selectedDayJs = dayjs(props.selectedDay);
                setValueDate(selectedDayJs);
                setBodyCalendar(prev => ({ ...prev, date: selectedDayJs }));
            }
            if (props.selectedDeviceId && deviceScreen.length > 0) {
                const deviceExists = deviceScreen.some(d => d.id === props.selectedDeviceId);
                if (deviceExists) {
                    setBodyCalendar(prev => ({ ...prev, device: props.selectedDeviceId, devices: [props.selectedDeviceId] }));
                } else {
                    console.warn('[ModalView] Device not found in deviceScreen:', props.selectedDeviceId);
                    setBodyCalendar(prev => ({ ...prev, device: '', devices: [] }));
                }
            }
        }
    }, [props.selectedDay, props.selectedDeviceId, props.V, deviceScreen])

    useEffect(() => {
        // Po výběru zařízení nastavit skupinu karet z roomGroup zařízení (NE z device_group 1/2).
        // Při otevření z Diplomat/SpecOffer s pevnou skupinou (groupLockedForAdd) nesmíme group_id přepisovat.
        if (groupLockedForAdd || isMenuCard || isNoGroupCard) return;
        if (!(selectedDisplay && props.V == 1 && displays.length > 0)) return;
        const display = displays.find((d) => d.id === selectedDisplay);
        if (!display) return;
        const rgRaw = display.roomGroup ?? display.room_group;
        const rg = rgRaw != null && rgRaw !== '' ? parseInt(String(rgRaw), 10) : NaN;
        if (Number.isFinite(rg) && rg > 0) {
            setgroup_id(rg);
            fetchExistingCards(rg);
        }
    }, [selectedDisplay, displays, groupLockedForAdd, isMenuCard, isNoGroupCard, props.V])

    // Default device selection in "Add Image" modal:
    // prefer kiosk (device_group=2) when available (Radisson workflow),
    // otherwise first display. This avoids "Save" staying disabled.
    useEffect(() => {
        const isAddModal = props.V == 1 && !props.currentID && !props.ModalBody?.id;
        if (!isAddModal) return;
        if (groupLockedForAdd || isMenuCard || isNoGroupCard) return; // no selection needed
        if (selectedDisplay) return;
        if (!Array.isArray(displays) || displays.length === 0) return;

        const kiosk = displays.find((d) => Number(d.device_group) === 2);
        const disp = displays.find((d) => Number(d.device_group) === 1);
        const pick = kiosk?.id ?? disp?.id ?? '';
        if (pick) setSelectedDisplay(pick);
    }, [props.V, props.currentID, props.ModalBody?.id, groupLockedForAdd, isMenuCard, isNoGroupCard, selectedDisplay, displays]);

    const fetchDisplays = async () => {
        try {
            const orgId = props.cred.cOrganization_id;
            const [dispRes, sgRes] = await Promise.all([
                axios.get(`${path}/getDisplaysbyOrg/${orgId}`),
                axios.get(`${path}/getSlideGroup?orgID=${encodeURIComponent(orgId)}`).catch(() => ({ data: [] })),
            ]);
            setDisplays(dispRes.data);
            setSlideGroups(Array.isArray(sgRes.data) ? sgRes.data : []);
        } catch (error) {
            console.error('Error fetching displays:', error);
        }
    };

    const fetchExistingCards = async (groupId) => {
        try {
            // Stejný přehled jako v Diplomat – bez device_group, ať se v náhledu ukážou všechny karty ve skupině
            const response = await axios.get(
                `${path}/getCardsV3?orgID=${props.cred.cOrganization_id}&group=${groupId}`
            );
            setExistingCards(response.data || []);
        } catch (error) {
            console.error('Error fetching existing cards:', error);
            setExistingCards([]);
        }
    };

    const handleUpload = async () => {
        //debugger;
        console.warn(props.cred.cOrganization_id)
        const hasFile = Boolean(file);
        const hasUrl = contentMode === 'url' && externalUrl.trim() !== '';
        if (!hasFile && !hasUrl) return;
        if (hasFile && file.size > MAX_UPLOAD_BYTES) {
            alert(`Soubor je moc velký. Maximum je ${MAX_UPLOAD_MB} MB.`);
            return;
        }
        // For "no group" (0) and menu cards (99) we don't require a display selection
        if (!groupLockedForAdd && !isMenuCard && !isNoGroupCard && !selectedDisplay) return;
        if (isUploading) return; // Prevent double-click
        setIsUploading(true);
        try {
            // Server handles PDF splitting + image generation in uploadV2.
            const formData = new FormData();
            if (hasFile) formData.append('file', file);
            if (hasUrl) formData.append('externalUrl', externalUrl.trim());
            formData.append('description', text);
            formData.append('id', props.cred.id);
            formData.append('cOrganization_id', props.cred.cOrganization_id);
            formData.append('groupID', group_id);
            const uploadRes = await axios.post(`${path}/uploadV2`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (props.updateCount) props.updateCount();
            const firstRow = Array.isArray(uploadRes.data) ? uploadRes.data[0] : null;
            if (firstRow && firstRow.videoProcessing) {
                alert(
                    'Soubor je nahrán. Video se na serveru převádí do formátu pro kiosky — dokončení může trvat minuty; displeje se obnoví po dokončení převodu.'
                );
            } else {
                alert('File uploaded successfully');
            }
            props.close();
        } catch (error) {
            console.error('Error uploading file:', error);
            const status = error?.response?.status;
            const backendMsg = error?.response?.data?.message || error?.response?.data?.error || '';
            const msg = String(backendMsg || '').trim();
            if (status === 413 || String(msg).toLowerCase().includes('too large')) {
                alert(`Soubor je moc velký. Maximum je ${MAX_UPLOAD_MB} MB.`);
            } else if (status === 502 || status === 504) {
                alert(
                    'Server vrátil 502/504 (brána/časový limit). U velkých videí Node dlouho překódovává ffmpeg; IIS má často limit ~120 s a ukončí spojení dřív. Na serveru zvyšte ARR proxy timeout (Application Request Routing → Server Proxy Settings) nebo nahrajte kratší / menší soubor.'
                );
            } else if (error?.code === 'ERR_NETWORK') {
                alert(
                    'Upload selhal na síti (CORS/proxy). Pokud testujete lokálně, používejte API http://localhost:3001 a restartujte client.'
                );
            } else if (msg) {
                alert(`Upload se nepodařil: ${msg}`);
            } else {
            alert('Error uploading file');
            }
        } finally {
            setIsUploading(false);
        }

    };
    const handleUpdate = async () => {
        //debugger;
        if (isUploading) return; // Prevent double-click
        setIsUploading(true);
        const formData = new FormData();
        const cardId = props.currentID || props.ModalBody?.id;
        if (!cardId) {
            alert('Card ID is missing');
            setIsUploading(false);
            return;
        }
        if (file) {
        formData.append('file', file);
        }
        formData.append('id', cardId);
        if (text && text.trim()) {
            formData.append('description', text.trim());
        }

        try {
            const response = await axios.post(`${path}/update`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            alert('Card updated successfully');
            props.close();
        } catch (error) {
            console.error('Error updating card:', error);
            let msg = 'Error updating card.';
            if (error.response?.status === 404) {
                msg = error.response?.data?.error || 'Card not found. The card may have been deleted – try closing and refreshing the list.';
            } else if (error.response?.data?.error) {
                msg = error.response.data.error;
            } else if (typeof error.response?.data === 'string' && error.response.data) {
                msg = error.response.data;
            }
            alert(msg);
            if (props.updateCount) props.updateCount();
            props.close();
        } finally {
            setIsUploading(false);
        }
    };

    const handleUpdateDefValue = async () => {
        setIsSend(true)
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('id', defaultIdNav);

        try {
            const response = await axios.post(`${path}/defaultscreenupdate`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            //console.error(response.data[0].id)
            //add_handler(response.data[0].id)
            //alert('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Error uploading file');
        }
        props.close()
    };
    const handleDeleteDefValue = async () => {
        try {
            await axios.delete(`${path}/defaultscreendelete/${defaultIdNav}`)
            console.log('Row deleted successfully');
            // Optionally, update your UI to reflect the deletion
            props.close()
        } catch (error) {
            console.error('Error deleting row:', error);
        }

    }

    const nullFile =
        <Button
            color={"primary"}
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon/>}
        >Upload file<VisuallyHiddenInput ref={fileInputRef} type="file" accept="image/*,video/*,application/pdf" onChange={handleFileChange}/></Button>


    const showPdfPreview = Boolean(file && isPdfFile(file) && !isVideoPreview);
    const notnullFile = <div className={classes.image}>
        {isVideoPreview ? (
            <video src={imageUrl} controls style={{ maxWidth: '100%', maxHeight: 220 }} />
        ) : showPdfPreview ? (
            <Box sx={{ textAlign: 'center', maxWidth: '100%' }}>
                <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                    PDF: {file?.name || 'soubor'}
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                    {'PDF · po uložení se rozdělí na obrázky'}
                </Typography>
            </Box>
        ) : (
            <img src={imageUrl} alt="" style={{ maxWidth: '100%', maxHeight: 220, objectFit: 'contain' }} />
        )}
        <Button variant="outlined" color={"error"} onClick={delete_file_handler} startIcon={<DeleteIcon/>}>
            Delete
        </Button>
    </div>

    const notnullFileWthoutPic = <div className={classes.fl}>
        <label>Media uploaded</label>
        <Button variant="outlined" color={"error"} onClick={delete_file_handler} startIcon={<DeleteIcon/>}>
            Delete
        </Button>
    </div>

    let deleteModal = (
        <div className={classes.ModalDel}>
            <div className={classes.ModalDelIcon}>
                <DeleteIcon />
            </div>
            <Typography className={classes.ModalDelTitle} variant="h6" component="p">
                Delete this card?
            </Typography>
            <Typography className={classes.ModalDelSub} variant="body2" color="text.secondary">
                This action cannot be undone.
            </Typography>
            <div className={classes.ModalDelActions}>
                <Button variant="outlined" onClick={close_handler} sx={{ minWidth: 100 }}>
                    Cancel
                </Button>
                <Button variant="contained" color="error" onClick={delete_handler} startIcon={<DeleteIcon />} sx={{ minWidth: 100 }}>
                    Delete
                </Button>
            </div>
        </div>
    )

    let previewAddModal = (
        <div className={`${classes.ModalCont2} ${classes.modalColumn}`}>
            <h2 style={{ 
                fontSize: 'clamp(1.2rem, 4vw, 1.5rem)',
                marginBottom: '20px',
                marginTop: '0',
                textAlign: 'center',
                width: '100%',
                padding: '0 10px',
                boxSizing: 'border-box'
            }}>Add Image</h2>
            <div className={classes.modalTwoCol}>
                <div className={classes.addLeft}>
                    <div className={classes.flex}>
                        {file === null ? nullFile : notnullFile}
                    </div>
                    {group_id && (
                        <div className={classes.existingSection}>
                            <div className={classes.existingHeader}>
                                <div className={classes.existingTitle}>Existing media</div>
                                <div className={classes.existingMeta}>
                                    Group <b>{group_id}</b> · <b>{existingCards.length}</b>
                                </div>
                            </div>

                            {existingCards.length > 0 ? (
                                <div className={classes.existingGrid}>
                                    {existingCards.map((card) => (
                                        <div
                                            key={card.id}
                                            className={classes.existingTile}
                                            title={card.description || ''}
                                        >
                                            {isVideoPath(card.path) ? (
                                                <video
                                                    className={classes.existingImg}
                                                    src={toPublicUploadUrl(card.path)}
                                                    controls
                                                    preload="metadata"
                                                    muted
                                                    onLoadedMetadata={(e) => {
                                                        try {
                                                            const v = e.currentTarget;
                                                            const t = Number.isFinite(v.duration) && v.duration > 1.1 ? 1 : 0;
                                                            v.currentTime = t;
                                                            v.pause();
                                                        } catch (_) {}
                                                    }}
                                                    onError={(e) => {
                                                        console.error('Error loading video:', card.path);
                                                        e.currentTarget.style.display = 'none';
                                                    }}
                                                />
                                            ) : isPdfPath(card.path) ? (
                                                <div className={classes.existingImg} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f3f3', color: '#333' }}>
                                                    PDF
                                                </div>
                                            ) : /^https?:\/\//i.test(String(card.path || '')) ? (
                                                <div className={classes.existingImg} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f3f3', color: '#333', fontSize: 12, textAlign: 'center', padding: 6 }}>
                                                    WEB URL
                                                </div>
                                            ) : (
                                            <img
                                                className={classes.existingImg}
                                                src={toPublicUploadUrl(card.path)}
                                                alt={card.description || 'Image'}
                                                onError={(e) => {
                                                    console.error('Error loading image:', card.path);
                                                        e.currentTarget.style.display = 'none';
                                                }}
                                            />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className={classes.existingEmpty}>
                                    No images in this group yet.
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className={classes.addRight}>
                    <div className={classes.modalRightForm}>
                        <FormControl sx={{ width: '100%', marginBottom: { xs: 1, sm: 2 } }}>
                            <InputLabel id="content-mode-select-label">Content type</InputLabel>
                            <Select
                                labelId="content-mode-select-label"
                                value={contentMode}
                                label="Content type"
                                onChange={(e) => setContentMode(e.target.value)}
                            >
                                <MenuItem value="file">File (image / video / PDF)</MenuItem>
                                <MenuItem value="url">Web URL / PDF URL</MenuItem>
                            </Select>
                        </FormControl>
                        {contentMode === 'url' && (
                            <TextField
                                sx={{ width: '100%', minWidth: 0, marginBottom: { xs: 1, sm: 2 } }}
                                id="external-url"
                                label="External URL"
                                placeholder="https://..."
                                variant="outlined"
                                value={externalUrl}
                                onChange={(e) => setExternalUrl(e.target.value)}
                                fullWidth
                            />
                        )}
                        <TextField
                            sx={{
                                width: '100%',
                                minWidth: 0,
                                marginBottom: { xs: 1, sm: 2 }
                            }}
                            id="header"
                            label="Description"
                            variant="outlined"
                            value={text}
                            onChange={handleTextChange}
                            fullWidth
                        />
                        {!groupLockedForAdd && !isMenuCard && !isNoGroupCard && !props.currentID && !props.ModalBody?.id && (
                            <>
                                <FormControl sx={{
                                    width: '100%',
                                    minWidth: 0,
                                    marginBottom: { xs: 1, sm: 2 }
                                }}>
                                    <InputLabel id="display-select-label">Select Device</InputLabel>
                                    <Select
                                        labelId="display-select-label"
                                        value={selectedDisplay}
                                        label="Select Device"
                                        onChange={(e) => setSelectedDisplay(e.target.value)}
                                    >
                                        {displays.map((display) => (
                                            <MenuItem key={display.id} value={display.id}>
                                                {display.description} ({display.device_group === 1 ? 'Display' : display.device_group === 2 ? 'Kiosk' : 'Unknown'})
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {selectedDisplay && (
                                    <FormControl sx={{
                                        width: '100%',
                                        minWidth: 0,
                                        marginBottom: { xs: 1, sm: 2 }
                                    }}>
                                        <InputLabel id="group-select-label">Group</InputLabel>
                                        <Select
                                            labelId="group-select-label"
                                            value={group_id}
                                            label="Group"
                                            onChange={(e) => {
                                                const newGroupId = e.target.value;
                                                setgroup_id(newGroupId);
                                                if (newGroupId) {
                                                    fetchExistingCards(newGroupId);
                                                } else {
                                                    setExistingCards([]);
                                                }
                                            }}
                                        >
                                            {slideGroups
                                                .filter((g) => g.groupId !== 1 && g.groupId !== 2)
                                                .map((g) => (
                                                <MenuItem key={g.groupId} value={g.groupId}>
                                                    {g.groupName || `Group ${g.groupId}`}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </>
                        )}
                        {groupLockedForAdd && (
                            <div className={classes.groupLockedBadge}>
                                Group: <b>{group_id}</b>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={classes.buttonSave}>
                <button onClick={close_handler} disabled={isUploading}>Cancel</button>
                <button
                    disabled={
                        isUploading ||
                        ((contentMode === 'file' ? file === null : !externalUrl.trim()) && !props.currentID && !props.ModalBody?.id && !groupLockedForAdd && !isMenuCard && !isNoGroupCard) ||
                        (!groupLockedForAdd && !isMenuCard && !isNoGroupCard && !text.trim()) ||
                        (!groupLockedForAdd && !isMenuCard && !isNoGroupCard && !selectedDisplay && !props.currentID && !props.ModalBody?.id)
                    }
                    onClick={handleSubmit}
                >
                    {isUploading ? 'Saving...' : (props.currentID || props.ModalBody?.id) ? 'Update' : 'Save'}
                </button>
            </div>
        </div>)

    const carouselItems = props.carouselItems || [];
    const carouselLen = carouselItems.length;
    const hasCarousel = props.V === 2 && carouselLen > 0;
    const currentCarouselCard = hasCarousel && carouselItems[carouselCurrentIndex];

    let previewCarouselModal = hasCarousel && currentCarouselCard && (
        <div className={classes.ModalCont}>
            <div className={classes.previewCarouselWrap}>
                <IconButton
                    aria-label="Předchozí"
                    className={classes.carouselArrow}
                    onClick={() => setCarouselCurrentIndex((i) => (i <= 0 ? carouselLen - 1 : i - 1))}
                    size="large"
                >
                    <ChevronLeftIcon />
                </IconButton>
                <div className={classes.previewCarouselImage}>
                    <img src={currentCarouselCard.Body?.imgURL} alt={currentCarouselCard.Header || ''} />
                </div>
                <IconButton
                    aria-label="Další"
                    className={classes.carouselArrow}
                    onClick={() => setCarouselCurrentIndex((i) => (i >= carouselLen - 1 ? 0 : i + 1))}
                    size="large"
                >
                    <ChevronRightIcon />
                </IconButton>
            </div>
            <div className={classes.previewCarouselFooter}>
                <span className={classes.previewCarouselCounter}>
                    {carouselCurrentIndex + 1} / {carouselLen}
                </span>
                {currentCarouselCard.Header && (
                    <span className={classes.previewCarouselTitle}>{currentCarouselCard.Header}</span>
                )}
                <Button variant="outlined" onClick={close_handler} sx={{ ml: 'auto' }}>Zavřít</Button>
            </div>
        </div>
    );

    let updateModal = (
        <div className={classes.ModalCont}>
            <div className={classes.addLeft}>
                <div className={classes.flex}>
                    {
                        file === null ? nullFile : notnullFile
                    }

                </div>
            </div>
            <div className={classes.addRight}>
                <TextField sx={{minWidth: 300}} id="outlined-basic" label="Description" variant="outlined" value={text}
                           disabled={true} onChange={handleTextChange}/>
            </div>
            <div className={classes.buttonSave}>
                <button onClick={close_handler} disabled={isUploading}>Cancel</button>
                <button disabled={isUploading || file === null ? true : false} onClick={handleUpdate}>
                    {isUploading ? 'Updating...' : 'Update'}
                </button>
            </div>
        </div>)

    const dialogPaperSx = {
        borderRadius: { xs: 0, sm: '12px' },
        maxHeight: { xs: '100vh', sm: '90vh' },
        margin: { xs: 0, sm: 16, md: 24 },
        width: { xs: '100%', sm: '98vw', md: '95vw', lg: '90vw' },
        maxWidth: { xs: '100%', sm: '1200px', md: '1400px', lg: '1600px' },
    };

    let previewAddModalforCal = (
        <Dialog open={true} onClose={close_handler} maxWidth={false} fullWidth PaperProps={{ sx: dialogPaperSx, mt: 2 }}>
            <DialogTitle sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px', padStartt: 2 }, fontWeight: 600, pb: 1.5, borderBottom: '1px solid #e0e0e0' }}>
                Add time slot
            </DialogTitle>
            <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: 2, px: { xs: 1.5, sm: 2, md: 3 }, overflowX: 'hidden', overflowY: 'auto' }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, sm: 2.5, md: 3 }, pt: { xs: 2, sm: 3 }, width: '100%', boxSizing: 'border-box', minWidth: 0 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: { xs: '100%', md: 260 }, maxWidth: { md: 280 }, flexShrink: 0 }}>
                        {file == null ? nullFile : notnullFile}
                    </Box>
                    <Box sx={{ flex: 1, minWidth: { xs: 0, sm: 0, md: 0}, maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: { xs: 2, sm: 2.5 }, boxSizing: 'border-box', overflow: 'hidden' }}>
                        <TextField fullWidth label={nameFieldLabel} variant="outlined" value={text ?? ''} onChange={handleTextChange} sx={{ mt: 1 }} />
                        {isFairmontOrg && (
                            <TextField fullWidth label="Subtitle" variant="outlined" value={subtitle ?? ''} onChange={(e) => setSubtitle(e.target.value)} />
                        )}
                        <FormControl fullWidth>
                            <InputLabel id="record-template-label">Choose existing company</InputLabel>
                            <Select
                                labelId="record-template-label"
                                label="Choose existing company"
                                value={selectedTemplateKey}
                                onChange={(e) => applyRecordTemplate(e.target.value)}
                            >
                                <MenuItem value="">
                                    <em>Manual input</em>
                                </MenuItem>
                                {(recordTemplates || []).map((t) => (
                                    <MenuItem key={t.key} value={t.key}>
                                        {t.name}{t.path ? ' (reuse logo)' : ''}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Devices (you can select multiple)</Typography>
                            <FormGroup sx={{ maxHeight: 200, overflowY: 'auto', pl: 0.5 }}>
                                {deviceScreen.length === 0 ? (
                                    <Typography variant="body2" color="text.secondary">No devices in organization</Typography>
                                ) : (
                                    deviceScreen.map((x) => (
                                        <FormControlLabel
                                            key={x.id}
                                            control={
                                                <Checkbox
                                                    checked={(bodyCalendar.devices || []).indexOf(x.id) !== -1}
                                                    onChange={() => {
                                                        const current = bodyCalendar.devices || [];
                                                        const has = current.indexOf(x.id) !== -1;
                                                        const next = has ? current.filter(id => id !== x.id) : [...current, x.id];
                                                        setBodyCalendar(prev => ({ ...prev, devices: next, device: next[0] || '' }));
                                                    }}
                                                    size="small"
                                                />
                                            }
                                            label={x.description || `Device ${x.id}`}
                                        />
                                    ))
                                )}
                            </FormGroup>
                            {(() => {
                                const ids = bodyCalendar.devices || [];
                                if (ids.length < 2) return null;
                                const names = ids
                                    .map(id => (deviceScreen.find(d => d.id === id)?.description || '').trim())
                                    .filter(Boolean);
                                const splits = names.map(n => {
                                    const m = n.match(/^(.*?)\s*(\S+)$/);
                                    return m ? { prefix: m[1].trim(), suffix: m[2] } : { prefix: n, suffix: '' };
                                });
                                const samePrefix = splits.length > 0 && splits.every(s => s.prefix === splits[0].prefix) && splits[0].prefix !== '';
                                if (samePrefix) {
                                    const suffixesSorted = splits
                                        .map(s => s.suffix)
                                        .sort((a, b) => {
                                            const na = parseFloat(a);
                                            const nb = parseFloat(b);
                                            if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
                                            return String(a).localeCompare(String(b));
                                        });
                                    const combined = `${splits[0].prefix} ${suffixesSorted.join(' + ')}`;
                                    return (
                                        <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'success.main' }}>
                                            Will be shown combined on the display: <strong>{combined}</strong>
                                        </Typography>
                                    );
                                }
                                return (
                                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                                        Rooms from different groups — each display will show only its own name.
                                    </Typography>
                                );
                            })()}
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker label="Date" value={bodyCalendar.date || valueDate} onChange={(v) => {
                                setValueDate(v);
                                setBodyCalendar({ ...bodyCalendar, date: v });
                            }}
                                slotProps={{ textField: { fullWidth: true } }} sx={{ width: '100%' }} />
                        </LocalizationProvider>
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1, md: 1.5 }, width: '100%', boxSizing: 'border-box' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="Start time"
                                    value={valueTime}
                                    onChange={(v) => setBodyCalendar({ ...bodyCalendar, timeFrom: v })}
                                    ampm={false}
                                    format="HH:mm"
                                    slotProps={{ textField: { fullWidth: true } }}
                                    sx={{ flex: { xs: '0 0 100%', md: '1 1 0' }, minWidth: { xs: '100%', md: 0 }, maxWidth: { xs: '100%', md: 'none' }, width: { xs: '100%', md: 'auto' } }}
                                />
                                <TimePicker
                                    label="End time"
                                    value={valueTime}
                                    onChange={(v) => setBodyCalendar({ ...bodyCalendar, timeTo: v })}
                                    ampm={false}
                                    format="HH:mm"
                                    slotProps={{ textField: { fullWidth: true } }}
                                    sx={{ flex: { xs: '0 0 100%', md: '1 1 0' }, minWidth: { xs: '100%', md: 0 }, maxWidth: { xs: '100%', md: 'none' }, width: { xs: '100%', md: 'auto' } }}
                                />
                            </LocalizationProvider>
                        </Box>
                        <FormControl fullWidth>
                            <InputLabel id="cal-add-show-label">Show before (minutes)</InputLabel>
                            <Select labelId="cal-add-show-label" value={showBefore ?? 0} label="Show before (minutes)"
                                onChange={(e) => { const v = Number(e.target.value); setShowBefore(v); setBodyCalendar(prev => ({ ...prev, showBefore: v })); }}>
                                {minutes.map((x) => <MenuItem key={x} value={x}>{x} minutes</MenuItem>)}
                            </Select>
                        </FormControl>
                        {isError && <Typography color="error" variant="body2">{(typeof isError === 'string') ? isError : 'All fields must be filled (name, device, date, time).'}</Typography>}

                        {/* ── Upload Poster ── */}
                        <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                Poster (full-screen on display)
                            </Typography>
                            {poster ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <img src={posterUrl} alt="poster preview" style={{ maxWidth: '100%', maxHeight: 160, objectFit: 'contain', borderRadius: 4, border: '1px solid #e0e0e0' }} />
                                    <Button variant="outlined" color="error" size="small" startIcon={<DeleteIcon />}
                                        onClick={() => { setPoster(null); setPosterUrl(''); if (posterInputRef.current) posterInputRef.current.value = ''; }}>
                                        Remove poster
                                    </Button>
                                </Box>
                            ) : (
                                <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} size="small">
                                    Upload poster
                                    <input ref={posterInputRef} type="file" accept="image/*" hidden onChange={(e) => {
                                        const f = e.target.files?.[0];
                                        if (!f) return;
                                        setPoster(f);
                                        setPosterUrl(URL.createObjectURL(f));
                                    }} />
                                </Button>
                            )}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, pt: 1, borderTop: '1px solid #e0e0e0' }}>
                <Button onClick={close_handler}>Cancel</Button>
                <Button variant="contained" onClick={validate_modal} disabled={!!isSend}>{isSend ? <CircularProgress size={24} /> : 'Save'}</Button>
            </DialogActions>
        </Dialog>
    )

    const editImageBlock = (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: { sm: 200 } }}>
            {imageUrlEdit ? (
                <Box sx={{ maxWidth: 250, maxHeight: 200, border: '1px solid #e0e0e0', borderRadius: 1, p: 1, bgcolor: '#f8f9fa' }}>
                    {isVideoEditPreview ? (
                        <video src={imageUrlEdit} controls style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                    <img src={imageUrlEdit} alt="Record" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    )}
                </Box>
            ) : null}
            <Button component="label" variant="contained" startIcon={<CloudUploadIcon />} sx={{ mt: 1 }}>
                {fileEdit ? 'Change media' : 'Upload media'}
                <VisuallyHiddenInput type="file" accept="image/*,video/*" onChange={handleFileEditChange} />
            </Button>
            {(imageUrlEdit || fileEdit) && (
                <Button size="small" color="error" onClick={delete_file_edit_handler} startIcon={<DeleteIcon />} sx={{ mt: 0.5 }}>Remove media</Button>
            )}
        </Box>
    );

    let previewUpdateDeleteModalforCal = (
        <Dialog open={true} onClose={close_handler} maxWidth="sm" fullWidth PaperProps={{ sx: dialogPaperSx }}>
            <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, fontWeight: 600, pb: 1.5, borderBottom: '1px solid #e0e0e0' }}>
                Edit time slot
            </DialogTitle>
            <DialogContent sx={{ pt: 3, pb: 2, px: { xs: 2, sm: 3 } }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, pt: 3 }}>
                    {editImageBlock}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField fullWidth label={nameFieldLabel} variant="outlined" value={textP} onChange={(e) => setTextP(e.target.value)} />
                        {isFairmontOrg && (
                            <TextField fullWidth label="Subtitle" variant="outlined" value={subtitleP ?? ''} onChange={(e) => setSubtitleP(e.target.value)} />
                        )}
                        <FormControl fullWidth>
                            <InputLabel id="cal-edit-device-label">Device</InputLabel>
                            <Select
                                labelId="cal-edit-device-label"
                                value={safeDeviceP}
                                label="Device"
                                onChange={(e) => setDeviceP(e.target.value)}
                            >
                                <MenuItem value="">Select device...</MenuItem>
                                {deviceScreen.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {x.description}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker label="Date" value={dayjs(dateAct.substring(0, 16))} onChange={setDateUpdate_handler}
                                slotProps={{ textField: { fullWidth: true } }} sx={{ width: '100%' }} />
                        </LocalizationProvider>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="Start time"
                                    value={(() => {
                                        const dateStr = dateFr.substring(0, 19).replace(' ', 'T');
                                        // Parse as local time without timezone conversion
                                        return dayjs(dateStr);
                                    })()}
                                    onChange={(v) => setDateTimeUpdate_handler(v, 1)}
                                    ampm={false}
                                    format="HH:mm"
                                    slotProps={{ textField: { fullWidth: true } }}
                                    sx={{ flex: 1, minWidth: 120 }}
                                />
                                <TimePicker
                                    label="End time"
                                    value={(() => {
                                        const dateStr = dateTo.substring(0, 19).replace(' ', 'T');
                                        // Parse as local time without timezone conversion
                                        return dayjs(dateStr);
                                    })()}
                                    onChange={(v) => setDateTimeUpdate_handler(v, 2)}
                                    ampm={false}
                                    format="HH:mm"
                                    slotProps={{ textField: { fullWidth: true } }}
                                    sx={{ flex: 1, minWidth: 120 }}
                                />
                            </LocalizationProvider>
                        </Box>
                        <FormControl fullWidth>
                            <InputLabel id="cal-edit-show-label">Show before (minutes)</InputLabel>
                            <Select labelId="cal-edit-show-label" value={showBefore ?? 0} label="Show before (minutes)"
                                onChange={(e) => { const v = Number(e.target.value); setShowBefore(v); setBodyCalendar(prev => ({ ...prev, showBefore: v })); }}>
                                {minutes.map((x) => <MenuItem key={x} value={x}>{x} minutes</MenuItem>)}
                            </Select>
                        </FormControl>
                        {/* ── Poster (full-screen on display) ── */}
                        <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                Poster (full-screen on display)
                            </Typography>
                            {posterUrlP ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <img src={posterUrlP} alt="poster preview" style={{ maxWidth: '100%', maxHeight: 160, objectFit: 'contain', borderRadius: 4, border: '1px solid #e0e0e0' }} />
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Button component="label" variant="outlined" size="small" startIcon={<CloudUploadIcon />}>
                                            Change poster
                                            <input ref={posterEditInputRef} type="file" accept="image/*" hidden onChange={(e) => {
                                                const f = e.target.files?.[0];
                                                if (!f) return;
                                                setPosterP(f); setPosterUrlP(URL.createObjectURL(f)); setRemovePosterP(false);
                                            }} />
                                        </Button>
                                        <Button variant="outlined" color="error" size="small" startIcon={<DeleteIcon />}
                                            onClick={() => { setPosterP(null); setPosterUrlP(''); setExistingPosterP(''); setRemovePosterP(true); if (posterEditInputRef.current) posterEditInputRef.current.value = ''; }}>
                                            Remove poster
                                        </Button>
                                    </Box>
                                </Box>
                            ) : (
                                <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} size="small">
                                    Upload poster
                                    <input ref={posterEditInputRef} type="file" accept="image/*" hidden onChange={(e) => {
                                        const f = e.target.files?.[0];
                                        if (!f) return;
                                        setPosterP(f); setPosterUrlP(URL.createObjectURL(f)); setRemovePosterP(false);
                                    }} />
                                </Button>
                            )}
                        </Box>
                        {isError && <Typography color="error" variant="body2">Time slot overlaps with an existing slot.</Typography>}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, pt: 1, borderTop: '1px solid #e0e0e0', flexWrap: 'wrap', gap: 1 }}>
                <Button color="error" onClick={handleDeleteRecord} startIcon={<DeleteIcon />}>Delete</Button>
                <Box sx={{ flex: 1 }} />
                <Button onClick={close_handler}>Cancel</Button>
                <Button 
                    variant="contained" 
                    onClick={handleUpdateRecord}
                    disabled={isUploading}
                >
                    {isUploading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>Updating...</span>
                        </Box>
                    ) : 'Update'}
                </Button>
            </DialogActions>
        </Dialog>
    )

    let default_set_modal = (
        <div className={classes.ModalCont}>

            <div className={classes.addLeft}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Screen location</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={defaultIdNav}
                        label="Screen location"
                        onChange={(event) => {
                            setDefaultIdNav(event.target.value)
                        }}
                    >
                        <MenuItem value={1}>Top</MenuItem>
                        <MenuItem value={2}>Bottom</MenuItem>
                    </Select>
                </FormControl>
                <div className={classes.flex}>
                    {
                        file === null ? nullFile : notnullFile
                    }

                </div>
            </div>
            <div className={classes.buttonSave1}>
                <Button variant="outlined" color={"success"} onClick={() => {
                    handleDeleteDefValue()
                }} startIcon={<DeleteIcon/>}>
                    Delete
                </Button>
                <Button variant="outlined" color={"success"} onClick={close_handler}>Cancel</Button>
                <Button disabled={file === null ? true : false || isSend && true} variant="contained" color={"success"}
                        onClick={() => {
                            handleUpdateDefValue()
                        }
                        }>{isSend ? <CircularProgress/> : "Update"}</Button>
            </div>
        </div>)


    const nullFile2 =
        <Button
            color={"error"}
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon/>}
        >UPLOAD FILE<VisuallyHiddenInput type="file" accept="image/*" onChange={handleFileChange2}/></Button>


    const notnullFile2 = <div className={classes.image}>
        <img src={imageUrl2}/>
        <Button variant="outlined" color={"error"} onClick={delete_file_handler2} startIcon={<DeleteIcon/>}>
            Delete
        </Button>
    </div>

    const nullFile3 =
        <Button
            color={"error"}
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon/>}
        >UPLOAD FILE<VisuallyHiddenInput type="file" accept="image/*" onChange={handleFileChange3}/></Button>


    const notnullFile3 = <div className={classes.image}>
        <img src={imageUrl3}/>
        <Button variant="outlined" color={"error"} onClick={delete_file_handler3} startIcon={<DeleteIcon/>}>
            Delete
        </Button>
    </div>

    let addExploreModal = (
        <div className={classes.ModalCont2}>
            <div className={classes.modalside}>
                <label>Graphics</label>
                {
                    file2 === null ? nullFile2 : notnullFile2
                }
            </div>
            <div className={classes.modalcenter}>
                <TextField
                    fullWidth
                    id="explore-header"
                    label="Header"
                    variant="outlined"
                    placeholder="Header"
                    value={textName}
                    onChange={(e) => setTextName(e.target.value)}
                />
                <TextField
                    fullWidth
                    id="explore-text"
                    label="Text"
                    variant="outlined"
                    placeholder="Text"
                    multiline
                    rows={6}
                    value={textCont}
                    onChange={(e) => setTextCont(e.target.value)}
                />
            </div>
            <div className={classes.modalside}>
                <label>QR</label>
                {
                    file3 === null ? nullFile3 : notnullFile3
                }
            </div>
            <div className={classes.buttonSave1}>
                <Button variant="outlined" color="success" onClick={close_handler} disabled={isUploading}>BACK</Button>
                <Button
                    variant="contained"
                    color="success"
                    disabled={isUploading || !file2 || !file3}
                    onClick={() => {
                        handleUploadExplore();
                    }}
                >
                    {isUploading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>Saving...</span>
                        </Box>
                    ) : 'ADD'}
                </Button>
            </div>
        </div>)


    return (<div className={classes.MainCont2}>
        {props.V === 0 && deleteModal}
        {props.V === 1 && previewAddModal}
        {props.V === 2 && (previewCarouselModal || updateModal)}
        {props.V === 3 && previewAddModalforCal}
        {props.V === 4 && previewUpdateDeleteModalforCal}
        {props.V === 5 && default_set_modal}
        {props.V === 6 && addExploreModal}
    </div>)
}

export default ModalView